import { AccessResult } from "utils/access";
import DiscardRunButton from "components/Run/elements/DiscardRunButton";
import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";

import { RunHistoryEntryType } from "../../types";

type ReadyEntryProps = {
  timestamp: number;
  until: number | null;
  showDiscardButton: boolean;
  canDiscard: AccessResult;
  stackId: string;
  runId: string;
  runQueryToRefetch: string;
};

const ReadyEntry = ({
  timestamp,
  until,
  showDiscardButton,
  canDiscard,
  stackId,
  runId,
  runQueryToRefetch,
}: ReadyEntryProps) => {
  return (
    <HistoryEntryWrapper state={RunHistoryEntryType.Ready} timestamp={timestamp} until={until}>
      {showDiscardButton && (
        <DiscardRunButton
          stackId={stackId}
          runId={runId}
          runQueryToRefetch={runQueryToRefetch}
          canDiscard={canDiscard}
        />
      )}
    </HistoryEntryWrapper>
  );
};

export default ReadyEntry;
